import plugin from '@hds/help-common/src/plugins/global-component-plugin'
import '@hds/help-common/src/assets/scss/common.scss'

export default plugin
